import { render, staticRenderFns } from "./PackageListItem.vue?vue&type=template&id=4c4c9ff2&scoped=true&"
import script from "./PackageListItem.vue?vue&type=script&lang=js&"
export * from "./PackageListItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageListItem.vue?vue&type=style&index=0&id=4c4c9ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c9ff2",
  null
  
)

export default component.exports